import { WebAPIBarGraphChartSlicerData } from '../../../../globals/webApiTypes/elements/WebAPICBS';
import { ValuesByComparingDimension } from '../barChart.types';
import { prepareBarChartDimension } from './prepareBarChartDimension';
import { sortByOrder } from './sortByOrder';

const filterFilledYAxisDimensionList =
	({
		valuesByComparingDimension,
	}: {
		valuesByComparingDimension: ValuesByComparingDimension;
	}) =>
	(searchKey: string) => {
		return valuesByComparingDimension.some(({ dataList }) => {
			return dataList.some(({ key }) => {
				return searchKey === key;
			});
		});
	};

const getFilledYAxisKeys = ({
	valuesByComparingDimension,
	yAxisDimension,
	topicKeys,
	categoryKeys,
}: { valuesByComparingDimension: ValuesByComparingDimension } & Pick<
	WebAPIBarGraphChartSlicerData,
	'yAxisDimension' | 'topicKeys' | 'categoryKeys'
>) => {
	if (yAxisDimension === 'DIMENSION_TOPIC') {
		return topicKeys.filter(
			filterFilledYAxisDimensionList({ valuesByComparingDimension }),
		);
	}

	return categoryKeys[yAxisDimension].filter(
		filterFilledYAxisDimensionList({ valuesByComparingDimension }),
	);
};

export const getBarChartYAxisEtries = ({
	valuesByComparingDimension,
	yAxisDimension,
	topicKeys,
	categoryKeys,
	selectedTopics,
	selectedCategories,
	labelAliases,
}: { valuesByComparingDimension: ValuesByComparingDimension } & Pick<
	WebAPIBarGraphChartSlicerData,
	| 'yAxisDimension'
	| 'topicKeys'
	| 'categoryKeys'
	| 'selectedTopics'
	| 'selectedCategories'
	| 'labelAliases'
>) => {
	const keys = getFilledYAxisKeys({
		yAxisDimension,
		valuesByComparingDimension,
		topicKeys,
		categoryKeys,
	});

	const entries = keys.map((key) => {
		if (yAxisDimension === 'DIMENSION_TOPIC') {
			return prepareBarChartDimension(labelAliases)(selectedTopics[key]);
		}

		return prepareBarChartDimension(labelAliases)(
			selectedCategories[yAxisDimension][key],
		);
	});

	return sortByOrder<
		Array<ReturnType<ReturnType<typeof prepareBarChartDimension>>>
	>(entries);
};
